import { initializeApp, getApps } from 'firebase/app';
import { 
  getAuth, 
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  onAuthStateChanged
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCMMMIfU4xBjcVyxH34K7czn0Wvhlxny4U",
  authDomain: "canvaforresume.firebaseapp.com",
  projectId: "canvaforresume",
  storageBucket: "canvaforresume.firebasestorage.app",
  messagingSenderId: "1059605343094",
  appId: "1:1059605343094:web:7f893f9fb17bf824f2a857",
  measurementId: "G-31ML3GHBR9"
};

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);

export { 
  auth, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut, 
  sendPasswordResetEmail,
  onAuthStateChanged 
};
